module.exports = __webpack_public_path__ + "457cfbe61892da22757b7865968b8e7c.png";